BOLD.options.app.on('option_products_loaded', function() {    
  let formChecked = false
  
  setInterval(function(){
    if(! formChecked){
      if($('.bold_error_message').length){
        if($('.bold_error_message:first').text().match(/必須項目を埋めてください。/)){
          formChecked = true
          $('.product-form__controls-group--submit').append('<span class="bold_error_message">※上記フォーム内の必須項目を埋めてください。</span>')
          
          //以下必須入力が必要なフォームが見えない場合に
          var scrollTop = $(window).scrollTop();
          var scrollBtm = scrollTop + $(window).height();
          
          var targetTop = $('.bold_error_message:first').offset().top;
          var targetBtm = targetTop + $('.bold_error_message:first').height();
          
          if(scrollBtm > targetTop && scrollTop < targetBtm) {
            
          } else {
            $("html,body").animate({scrollTop:$('.bold_error_message:first').parent().offset().top});
          }
        }
      }
    }
  },1000)
})